import { useQuery } from '@tanstack/react-query';
import { useLoaderData, useParams } from 'react-router';
import { getSystemSimulationQuery } from '~/shared/api/simulations.queries';
import { SimulationModel } from '~/shared/models/system/SimulationModel';
import { assertIsDefined } from '~/types/assert-type';

export function useOptionalSimulation() {
  const initialData = useLoaderData() as { simulation: SimulationModel };

  const { simulationId } = useParams<'simulationId'>();
  const { data: simulation } = useQuery({
    ...getSystemSimulationQuery({ simulationId: simulationId ?? '' }),
    initialData: initialData?.simulation,
    enabled: !!simulationId,
  });

  return simulation;
}

export function useRequiredSimulation() {
  const simulation = useOptionalSimulation();
  assertIsDefined(simulation);

  return simulation;
}
